import * as React from 'react';
import { useState } from 'react';
import { Property } from '../../../../../api/Property';
import { textLink } from '../../../../../api/ProspectUser';
import Button from '../../../../common/form/Button';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../../common/LoadingOverlay';

interface Props {
    property: Property;
}

const CheckpointIdMobileLink = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();
    const [hasSent, setHasSent] = useState(false);

    const sendLink = async () => {
        setLoading(true);
        let result = await textLink(location.pathname);
        if (result.error) {
            setError(result.error);
        }
        setHasSent(true);
        setLoading(false);
    };

    return (
        <div>
            <LoadingOverlay show={loading} inBootstrapColumn={true} />
            <p>
                {props.property.name} requires ID verification from your mobile phone. Once ID
                verification is complete on mobile, you can finish signup there or refresh this page
                to continue signup here.
            </p>
            <FormValidationDisplay errorMessage={error} />
            <Button
                onClick={sendLink}
                text={hasSent ? 'Send the link again' : 'Text me the link'}
            />
        </div>
    );
};

export default CheckpointIdMobileLink;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/verification/CheckpointIdMobileLink.tsx